import { z } from 'zod'
import { fallback } from '../../../../utilities'
import { colorSchema } from './colors'

const fallbackData = {
	fillMode: 'none',
	fillFlatColor: '#000000',
	fillBlendMode: 'normal',
	maskMode: 'flat',
	maskFlatOpacity: 0,
	maskGradientDirection: 'to-t',
	maskGradientStop1: 0,
	maskGradientStop2: 1,
	maskGradientOpacity1: 1,
	maskGradientOpacity2: 0,
} as const

const fillModeSchema = z.enum(['none', 'flat']).or(fallback(fallbackData.fillMode))
const fillFlatColorSchema = colorSchema.or(fallback(fallbackData.fillFlatColor))
const fillBlendModeSchema = z.enum([
	'normal',
	'multiply',
	'screen',
	'overlay',
	'darken',
	'lighten',
	'color-dodge',
	'color-burn',
	'hard-light',
	'soft-light',
	'difference',
	'exclusion',
	'hue',
	'saturation',
	'color',
	'luminosity',
]).or(fallback(fallbackData.fillBlendMode))
const maskModeSchema = z.enum(['flat', 'gradient']).or(fallback(fallbackData.maskMode))
const maskFlatOpacitySchema = z.number().min(0).max(1).or(fallback(fallbackData.maskFlatOpacity))
const maskGradientDirectionSchema = z.enum(['to-r', 'to-l', 'to-t', 'to-b', 'to-tr', 'to-tl', 'to-br', 'to-bl']).or(
	fallback(fallbackData.maskGradientDirection),
)
const maskGradientStop1Schema = z.number().min(0).max(1).or(fallback(fallbackData.maskGradientStop1))
const maskGradientStop2Schema = z.number().min(0).max(1).or(fallback(fallbackData.maskGradientStop2))
const maskGradientOpacity1Schema = z.number().min(0).max(1).or(fallback(fallbackData.maskGradientOpacity1))
const maskGradientOpacity2Schema = z.number().min(0).max(1).or(fallback(fallbackData.maskGradientOpacity2))

export const metaOverlaySchema = z.object({
	fillMode: fillModeSchema,
	fillFlatColor: fillFlatColorSchema,
	fillBlendMode: fillBlendModeSchema,
	maskMode: maskModeSchema,
	maskFlatOpacity: maskFlatOpacitySchema,
	maskGradientDirection: maskGradientDirectionSchema,
	maskGradientStop1: maskGradientStop1Schema,
	maskGradientStop2: maskGradientStop2Schema,
	maskGradientOpacity1: maskGradientOpacity1Schema,
	maskGradientOpacity2: maskGradientOpacity2Schema,
}).or(fallback(fallbackData))

export const metaOverlayDefault: MetaOverlayConfiguration = metaOverlaySchema.parse({})

export type MetaOverlayConfiguration = z.infer<typeof metaOverlaySchema>
